//Forms
export const LOOK_UP_FORM = 'lookUpForm';
export const SIGN_UP_FORM = 'signUpForm';
export const SOCIAL_SIGN_UP_FORM = 'SocialSignUpForm';
export const LOG_IN_FORM = 'logInForm';
export const LINK_ACCOUNTS_LOG_IN_FORM = 'linkAccountsLogInForm';
export const SET_PASSWORD_FORM = 'setPasswordForm';
export const FORGOT_PASSWORD_FORM = 'forgotPasswordForm';
export const LINKED_SOFT_ACCOUNTS_FORM = 'LinkedSoftAccountsForm';
export const PASSWORDLESS_FORM = 'passwordlessForm';

// URLs and Paths
export const BASE_URL = '/signin';
export const CHECKOUT_URL = '/checkout-external';
export const LOG_IN_PATH = 'login';
export const SIGN_UP_PATH = 'signup';
export const CHECKOUT_PATH = 'checkout';
export const LINK_ACCOUNTS_LOG_IN_PATH = 'link_accounts_login';
export const RESET_PASSWORD_PATH = 'resetpassword';
export const SET_PASSWORD_PATH = 'setpassword';
export const SET_LINKED_SOFT_ACCOUNTS_PATH = 'linkedSoftAccounts';
export const CONFIRMATION_PATH = 'confirmation';
export const EXISTING_ACCOUNT_PATH = 'existingAccount';
export const SOCIAL_LOOK_UP_PATH = 'socialLookup';
export const SOCIAL_LOG_IN_PATH = 'socialLogin';
export const SOCIAL_SIGN_UP_PATH = 'social_signup';
export const PASSWORDLESS_PAGE_PATH = 'passwordless';
export const COMPLETE_SIGN_UP_PATH = '/signin/signup';

// Status Paths
export const STATUS_PATH = 'status';
export const RESET_PASSWORD_STATUS_PATH = 'pass-reset';
export const SOFT_ACCOUNT_STATUS_PATH = 'pass-set';
export const LINK_SOCIAL_ACCOUNT_PATH = 'link-social-account'; // when social account is linked or not

export const PASSWORD_SET_TOKEN = 'h';
export const PASSWORD_MUST_LINK_ACCOUNT = 'must_link_account';
export const PASSWORD_EXTERNAL_PROVIDER = 'external_provider';
export const PASSWORD_SET_DESTINATION = 'destination';
export const INVALID_RESET_TOKEN = 'reset_token_invalid';

//Error codes
export const CAPTCHA_FIELD = 'captcha';
export const EXTERNAL_USER_EMAIL_ALREADY_USED_ERROR =
    'EXTERNAL_USER_EMAIL_ALREADY_USED';
export const EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT_ERROR =
    'EXTERNAL_USER_EMAIL_USED_ON_SOFT_ACCOUNT';
export const EXTERNAL_USER_WITHOUT_EMAIL_ERROR = 'EXTERNAL_USER_WITHOUT_EMAIL';
export const EMAIL_PERMISSION_DENIED_ERROR = 'EMAIL_PERMISSION_DENIED';
export const TOKEN_NOT_AUTHORIZED_ERROR = 'TOKEN_NOT_AUTHORIZED';
export const EXTERNAL_USER_UNKNOWN_ERROR = 'EXTERNAL_USER_UNKNOWN';
export const INVALID_SOCIAL_LOGIN_FIELD = 'INVALID_SOCIAL_LOGIN_FIELD';
export const SUSPENDED_ACCOUNT = 'SUSPENDED_ACCOUNT';
export const ARGUMENTS_ERROR = 'ARGUMENTS_ERROR';
export const EXTERNAL_UNKNOWN_ERROR = 'EXTERNAL_UNKNOWN_ERROR';
export const LOOKUP_SOCIAL_USER_EXISTENT = 'LOOKUP_SOCIAL_USER_EXISTENT';
export const LOOKUP_SOCIAL_USER_UNEXISTENT = 'LOOKUP_SOCIAL_USER_UNEXISTENT';
export const LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT =
    'LOOKUP_SOCIAL_USER_EXISTENT_IN_SOFT_ACCOUNT';
export const LOOKUP_SOCIAL_USER_EXISTENT_IN_FACEBOOK_SOFT_ACCOUNT =
    'LOOKUP_SOCIAL_USER_EXISTENT_IN_FACEBOOK_SOFT_ACCOUNT';
export const LOOKUP_SOCIAL_USER_EXISTENT_IN_GOOGLE_SOFT_ACCOUNT =
    'LOOKUP_SOCIAL_USER_EXISTENT_IN_GOOGLE_SOFT_ACCOUNT';
export const USER_ALREADY_HAS_EXTERNAL_PROVIDER =
    'USER_ALREADY_HAS_EXTERNAL_PROVIDER';
export const STAFF_USER_NOT_ALLOWED_ERROR = 'STAFF_USER_NOT_ALLOWED';

export const STATUS_TYPES = [
    RESET_PASSWORD_STATUS_PATH,
    SOFT_ACCOUNT_STATUS_PATH,
];

export const ONBOARDING_REDIRECT_URL_BLACKLIST = [
    'create',
    'oauth',
    'organizations',
];

//Returns from api SetLinkAccount
export const SET_LINK_ACCOUNT_OK = 'SET_LINK_ACCOUNT_OK';
export const SET_LINK_ACCOUNT_ERROR = 'SET_LINK_ACCOUNT_ERROR';
export const SET_LINK_ACCOUNT_TOKEN_EXPIRED = 'SET_LINK_ACCOUNT_TOKEN_EXPIRED';
export const SET_LINK_ACCOUNT_OTHER_ERROR = 'SET_LINK_ACCOUNT_OTHER_ERROR';

export const STLD_ENABLED = '1';
export const STLD_DISABLED = '';

export const PATHS_WITH_HEADER = [
    `${BASE_URL}/${LINK_SOCIAL_ACCOUNT_PATH}`,
    `${BASE_URL}/${LINK_SOCIAL_ACCOUNT_PATH}/`,
    `${BASE_URL}/${STATUS_PATH}/${SOFT_ACCOUNT_STATUS_PATH}`,
    `${BASE_URL}/${STATUS_PATH}/${SOFT_ACCOUNT_STATUS_PATH}/`,
    `${BASE_URL}/${STATUS_PATH}/${RESET_PASSWORD_STATUS_PATH}`,
    `${BASE_URL}/${STATUS_PATH}/${RESET_PASSWORD_STATUS_PATH}/`,
];

//Passwordless Login result
export const PASSWORDLESS_LOGIN_OK = 'PASSWORDLESS_LOGIN_OK';
export const PASSWORDLESS_LOGIN_NOT_AUTHORIZED =
    'PASSWORDLESS_LOGIN_NOT_AUTHORIZED';
export const PASSWORDLESS_LOGIN_TOKEN_EXPIRED =
    'PASSWORDLESS_LOGIN_TOKEN_EXPIRED';
export const PASSWORDLESS_LOGIN_OTHER_ERROR = 'PASSWORDLESS_LOGIN_OTHER_ERROR';
export const PASSWORDLESS_LOGIN_MUST_ACCEPT_TOS =
    'PASSWORDLESS_LOGIN_MUST_ACCEPT_TOS';
